import { render, staticRenderFns } from "./RoomChip.vue?vue&type=template&id=d93d704e"
import script from "./RoomChip.vue?vue&type=script&lang=js"
export * from "./RoomChip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports